import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchWareHouseList = createAsyncThunk("fetchWareHouseList", async ({ page, limit, filters }, { rejectWithValue }) => {
	const paramsObj = {
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
	};

	if (filters && (filters.is_active === true || filters.is_active === false)) {
		paramsObj.is_active = filters.is_active;
	}

	const params = new URLSearchParams(paramsObj);

	try {
		const response = await axiosHttp.get(`warehouses?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const WarehouseListSlice = createSlice({
	name: "WarehouseListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchWareHouseList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchWareHouseList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.current_page || 1;
			state.total = action.payload.total || 0;
		});

		builder.addCase(fetchWareHouseList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default WarehouseListSlice.reducer;
